import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ComponentsModule, FormModule } from "@stdoutsrl/design-kit";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { UserComponent } from "./pages/user/user.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslocoRootModule } from "./transloco-root.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ExampleMonouseComponent } from "./tables-custom-actions/example-table-component.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { EmployeeSheetComponent } from "./pages/calendar/calendar.component";
import { CalendarioMiglioreComponent } from "./pages/calendario-migliore/calendario-migliore.component";
import { ReportComponent } from "./pages/report/report.component";
import { CreateDatesComponent } from "./tables-custom-actions/custom-dates.component";
import { ModalStoreDateComponent } from "./tables-custom-actions/modal-store-date/modal-store-date.component";
@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    LoginComponent,
    UserComponent,
    ExampleMonouseComponent,
    RecoveryPasswordComponent,
    ChangePasswordComponent,
    EmployeeSheetComponent,
    CalendarioMiglioreComponent,
    ReportComponent,
    CreateDatesComponent,
    ModalStoreDateComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslocoRootModule,
    ComponentsModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
